const addAriaLabelToExternalLinks = () => {
    const externalLinks = document.querySelectorAll("a.external-link");
    externalLinks.forEach((link) => {
        link.setAttribute("aria-label", `${link.textContent}, externe link`);
    });
};
export default addAriaLabelToExternalLinks;
